import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68687fd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back" }
const _hoisted_2 = {
  key: 0,
  class: "section-title"
}
const _hoisted_3 = { class: "header-left margin-left-15" }
const _hoisted_4 = { class: "header-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.title || _ctx.$slots['header-left'] || _ctx.$slots['header-right'])
      ? (_openBlock(), _createElementBlock("dl", _hoisted_2, [
          _createElementVNode("dt", null, [
            _createElementVNode("p", {
              class: _normalizeClass({
            'title-require': _ctx.required,
          })
            }, _toDisplayString(_ctx.title), 3),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "header-left", {}, undefined, true)
            ])
          ]),
          _createElementVNode("dd", _hoisted_4, [
            _renderSlot(_ctx.$slots, "header-right", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}